<script>
  import { onMount, afterUpdate } from "svelte";
  import Quill from "quill";

  export let options = [
    ["bold", "italic", "underline"],
    [{ color: [] }, { background: [] }],
    [{ align: [] }],
    ["link"],
    ["clean"]
  ];

  export let value = "";
  export let label = "";
  let quill;
  let container;

  $: if (quill && quill.root.innerHTML !== value) {
    quill.root.innerHTML = value;
  }

  afterUpdate(() => {
    if (!quill && container) {
      quill = new Quill(container, {
        modules: { toolbar: options },
        theme: "snow"
      });
      quill.root.innerHTML = value;

      quill.on("text-change", (delta, oldDelta, source) => {
        value = quill.root.innerHTML;
        // console.log("Value: ", value);
      });
    }
  });
</script>

<style>
  .editor {
    min-height: 180px;
    min-width: 380px;
    border-radius: 0px 4px 4px 0px;
    border-color: black;
  }
</style>

<svelte:head>
  <link rel="stylesheet" href="//cdn.quilljs.com/1.3.6/quill.snow.css" />
</svelte:head>

<div>
  <label>{label}</label>
  <div bind:this={container} class="editor" />
</div>
